var map = {
	"./img.png": 1954,
	"./img1.png": 1717,
	"./img10.png": 1718,
	"./img2.png": 1719,
	"./img3.png": 1720,
	"./img4.png": 1721,
	"./img5.png": 1722,
	"./img6.png": 1723,
	"./img7.png": 1724,
	"./img8.png": 1725,
	"./img9.png": 1726
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1953;